import { motion } from "framer-motion";
import { OFFERINGS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

const SPAN = {
  food: "md:col-span-2 md:row-span-2",
  music: "md:col-span-2",
};

function Tile({ item, index }) {
  const Icon = item.icon;
  return (
    <Reveal
      delay={index * 0.06}
      className={`${SPAN[item.key] || "md:col-span-1"} group relative overflow-hidden rounded-md border border-white/10 min-h-[240px]`}
    >
      <div
        data-testid={`offering-${item.key}`}
        className="relative h-full w-full"
      >
        <motion.img
          src={item.image}
          alt={item.title}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ filter: "brightness(0.62)" }}
          initial={{ scale: 1 }}
          whileHover={{ scale: 1.07 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B132B] via-[#0B132B]/30 to-transparent" />
        <div className="relative z-10 flex h-full flex-col justify-end p-6 md:p-8">
          <span className="mb-4 grid h-11 w-11 place-items-center rounded-full bg-primary/90 text-primary-foreground transition-transform duration-500 group-hover:-translate-y-1">
            <Icon className="h-5 w-5" />
          </span>
          <h3 className="font-display text-2xl md:text-3xl text-[#F8F5F2]">
            {item.title}
          </h3>
          <p className="mt-2 max-w-md text-sm text-[#F8F5F2]/75 leading-relaxed">
            {item.blurb}
          </p>
        </div>
      </div>
    </Reveal>
  );
}

export default function Offerings() {
  return (
    <section
      id="offerings"
      data-testid="offerings-section"
      className="relative bg-[#0B132B] py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal>
              <span className="font-label text-xs text-primary">
                What We Offer
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-display text-5xl md:text-7xl text-[#F8F5F2]">
                Everything you <br className="hidden md:block" />
                came for.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-[#F8F5F2]/70 text-base leading-relaxed">
              Six reasons Bellevue keeps coming back — from the kitchen to the
              stage, every night at Alley Pub has something going on.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:auto-rows-[260px]">
          {OFFERINGS.map((item, i) => (
            <Tile key={item.key} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
